export default __webpack_public_path__ + "static/media/logo-nkp.f5d8d8ef.jpg";